import React, {useEffect} from "react";
import styles from "./BotTableControls.module.css";
import {BroomButton} from "../../../../elements/broomButton/BroomButton";
import {SearchField} from "../../../../elements/searchField/SearchField";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    defaultBotTableRequest,
    resetBotTableRequest,
    botTableRequestSelector,
    updateBotTableRequest
} from "../../botListSlice";
import {BotType} from "../../../../../api/generated";
import {SelectOption} from "../../../../elements/select/SelectDropdown";
import {getBotTypeTitle} from "../../../../../utils/enumValueTitleUtil";
import {fetchFranchises, franchiseOptionsSelector} from "../../../franchise/franchiseSlice";

export const BotTableControls: React.FC = () => {

    const dispatch = useAppDispatch()
    const botTableRequest = useAppSelector(botTableRequestSelector)
    const franchises = useAppSelector(franchiseOptionsSelector)

    useEffect(() => {
        dispatch(fetchFranchises())
    }, [dispatch])

    const getBotTypeOptions = (): SelectOption<BotType>[] => {
        return Object.values(BotType).map(botType => ({
            value: botType,
            label: getBotTypeTitle(botType)
        }))
    }

    const getFranchiseOptions = (): SelectOption<string>[] => {
        return franchises.map(franchise => ({
            value: franchise.publicId,
            label: franchise.name
        }))
    }

    const updateFranchiseFilter = (franchisePublicIds: string[]) => {
        dispatch(updateBotTableRequest({franchisePublicIds}))
    }

    const resetFilters = () => {
        if (botTableRequest.searchQuery !== defaultBotTableRequest.searchQuery ||
            botTableRequest.botTypes !== defaultBotTableRequest.botTypes ||
            botTableRequest.franchisePublicIds !== defaultBotTableRequest.franchisePublicIds) {
            dispatch(resetBotTableRequest())
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.controls}>
            <SearchField
                value={botTableRequest.searchQuery}
                placeholder={'Search Dealer Name, Hash'}
                onChange={newValue => dispatch(updateBotTableRequest({searchQuery: newValue}))}
            />
            <MultiSelectTableFilterDropdown<BotType, {}>
                value={botTableRequest.botTypes}
                placeholder={"Filter by Bot Type"}
                width={240}
                handleChange={(botTypes) => dispatch(updateBotTableRequest({botTypes}))}
                options={getBotTypeOptions()}
            />
            <MultiSelectTableFilterDropdown<string, {}>
                value={botTableRequest.franchisePublicIds}
                placeholder={"Filter by Franchise"}
                width={500}
                handleChange={updateFranchiseFilter}
                options={getFranchiseOptions()}
            />
        </div>
        <div className={styles.clearButton}>
            <BroomButton disabled={false} handleClick={resetFilters}/>
        </div>
    </div>
}
